export const pageStyle = {
  display: 'grid',
  gap: 16,
};

export const headerStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 12,
  flexWrap: 'wrap',
  padding: '18px 20px',
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
};

export const titleWrapStyle = {
  display: 'flex',
  alignItems: 'center',
  gap: 10,
};

export const titleStyle = {
  margin: 0,
  fontSize: 22,
  fontWeight: 800,
  color: 'var(--text)',
};

export const selectStyle = {
  minWidth: 180,
  height: 38,
  padding: '0 10px',
  borderRadius: 8,
  border: '1px solid var(--border)',
  background: 'var(--bg-card)',
  color: 'var(--text)',
  fontSize: 14,
};

export const gridStyle = {
  display: 'grid',
  gridTemplateColumns: 'repeat(auto-fit, minmax(260px, 1fr))',
  gap: 12,
};

export const cardStyle = {
  display: 'grid',
  gap: 12,
  alignContent: 'start',
  minHeight: 150,
  padding: 16,
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
};

export const cardHeadStyle = {
  display: 'flex',
  alignItems: 'center',
  justifyContent: 'space-between',
  gap: 10,
};

export const cardTitleStyle = {
  margin: 0,
  fontSize: 16,
  fontWeight: 800,
  color: 'var(--text)',
};

export const cardSubStyle = {
  margin: 0,
  minHeight: 38,
  color: 'var(--text-sub)',
  fontSize: 13,
  lineHeight: 1.45,
};

export const actionRowStyle = {
  display: 'flex',
  gap: 8,
  flexWrap: 'wrap',
  marginTop: 'auto',
};

export const primaryButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  minHeight: 36,
  padding: '0 12px',
  border: '1px solid #2563eb',
  borderRadius: 8,
  background: '#2563eb',
  color: '#fff',
  fontWeight: 800,
  cursor: 'pointer',
};

export const outlineButtonStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  justifyContent: 'center',
  gap: 6,
  minHeight: 36,
  padding: '0 12px',
  border: '1px solid var(--border)',
  borderRadius: 8,
  background: 'var(--bg-card)',
  color: 'var(--text)',
  fontWeight: 700,
  cursor: 'pointer',
};

export const disabledButtonStyle = {
  ...outlineButtonStyle,
  opacity: 0.45,
  cursor: 'not-allowed',
};

export const badgeStyle = {
  display: 'inline-flex',
  alignItems: 'center',
  height: 24,
  padding: '0 8px',
  borderRadius: 999,
  background: 'rgba(37,99,235,0.1)',
  color: '#2563eb',
  fontSize: 12,
  fontWeight: 800,
};
